import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router';
import { ArrowRight } from 'lucide-react';
import { useSessao } from '../sessao';
import logo from '../assets/logo-ondark.png';

export function Entrar() {
  const { usuario, entrar } = useSessao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (usuario) return <Navigate to="/" replace />;

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'Não foi possível entrar.');
      setSenha('');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="entrar">
      <section className="entrar-marca escuro">
        <img src={logo} alt="Vivium" className="entrar-logo" />
        <div>
          <span className="kicker">Gestão de serviços de campo</span>
          <h1 className="titulo-display">
            Vivium <span>Ops</span>
          </h1>
          <p className="lead">Chamados, ordens de serviço e parque instalado no mesmo lugar. Do pedido do síndico ao fechamento em campo.</p>
        </div>
        <small className="endosso">Uma marca Maza Automação.</small>
      </section>
      <section className="entrar-form">
        <form className="cartao" onSubmit={enviar} noValidate>
          <span className="kicker">Acesso restrito</span>
          <h2 className="titulo">Entrar</h2>
          <label>
            E-mail
            <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
          </label>
          <label>
            Senha
            <input type="password" autoComplete="current-password" required value={senha} onChange={(e) => setSenha(e.target.value)} />
          </label>
          {erro && <p className="alerta" role="alert">{erro}</p>}
          <button className="btn" type="submit" disabled={enviando || !email || !senha}>
            {enviando ? 'Entrando…' : 'Entrar'} <ArrowRight size={18} strokeWidth={2} aria-hidden />
          </button>
        </form>
      </section>
    </div>
  );
}
